export enum AuthStep {
    ROLE_SELECTION = 'role-selection',
    ADMIN_LOGIN = 'admin-login',
    SUB_ADMIN_LOGIN = 'sub-admin-login'
}

export enum UserRole {
    ADMIN = 'admin',
    SUB_ADMIN = 'sub-admin'
}

export enum RoutePath {
    DASHBOARD = 'dashboard',
    USERS = 'users',
    SETTINGS = 'settings',
    LOGIN = 'login'
}
